import i18n from '@/i18n'
import dayjs from 'dayjs'

export const formatHHMM = (date) => {
  if (!date) return ''

  const parsed = new Date(date)
  if (isNaN(parsed.getTime())) return ''

  return parsed.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  })
}

export const formatTimeStringToDate = (value) => {
  if (!value) return
  const fixed = value.replace(' ', 'T')
  const date = new Date(fixed)

  if (isNaN(date)) return '-'

  return date.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  })
}
export const formatHHMMDD = (dateString) => {
  const now = new Date()
  const target = new Date(dateString)

  const diffMs = now - target
  const diffMin = Math.floor(diffMs / (1000 * 60))
  const diffHour = Math.floor(diffMs / (1000 * 60 * 60))

  if (diffMin < 60) {
    return i18n.t('format.time.minutesAgo', { count: diffMin })
  }

  if (diffHour < 24) {
    return i18n.t('format.time.hoursAgo', { count: diffHour })
  }

  const yyyy = target.getFullYear()
  const mm = String(target.getMonth() + 1).padStart(2, '0')
  const dd = String(target.getDate()).padStart(2, '0')
  const hh = String(target.getHours()).padStart(2, '0')
  const min = String(target.getMinutes()).padStart(2, '0')

  return `${yyyy}-${mm}-${dd}, ${hh}:${min}`
}

export const formatDate = (dateStr) => {
  return dayjs(dateStr).format(i18n.t('format.time.dateTime'))
}

export const formatDateForTooltip = (dateStr, timeStr, mode) => {
  const date = dayjs(`${dateStr}T${timeStr}`)
  switch (mode) {
    case 'I':
    case 'H':
      return date.format('YYYY.MM.DD HH:mm')
    case 'D':
    case 'W':
      return date.format('YYYY.MM.DD')
    case 'M':
      return date.format('YYYY.MM')
    default:
      return ''
  }
}

export const formatDateTime = (dateString, { short = false } = {}) => {
  if (!dateString) return ''

  const date = dayjs(dateString)

  if (!date.isValid()) return '-'

  if (short) return date.format('YY.MM.DD HH:mm')

  return date.format('YYYY. MM. DD HH:mm')
}

const MINUTE_MS = 60 * 1000

export const formatMStockNewsRelativeTime = (dateString, currentTime = new Date()) => {
  if (!dateString) return ''

  const normalizedDateString =
    typeof dateString === 'string' ? dateString.replace(' ', 'T') : dateString

  const publishedTime = new Date(normalizedDateString)
  const now = new Date(currentTime)

  if (Number.isNaN(publishedTime.getTime()) || Number.isNaN(now.getTime())) {
    return '-'
  }

  const currentMinute = Math.floor(now.getTime() / MINUTE_MS)
  const publishedMinute = Math.floor(publishedTime.getTime() / MINUTE_MS)

  const diffMinutes = Math.max(0, currentMinute - publishedMinute)

  if (diffMinutes < 1) {
    return '1분 전'
  }

  if (diffMinutes < 60) {
    return `${diffMinutes}분 전`
  }

  const diffHours = Math.floor(diffMinutes / 60)

  if (diffHours < 24) {
    return `${diffHours}시간 전`
  }

  return dayjs(publishedTime).format('YYYY.MM.DD')
}

export const formatBaseDate = (dateString) => {
  if (!dateString) return ''

  const date = dayjs(dateString)

  if (!date.isValid()) return ''

  return date.format('YYYY. MM. DD')
}
